import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { pantherRedirectGuard } from './pages/software-plans/panther-redirect.guard';
import { subscriptionSelectionGuard } from './pages/subscription-page/subscription-selection.guard';
import { incompleteOrderRedirectGuard } from './account-portal/incomplete-order-redirect.guard';
import {
  signedAgreementBackGuard,
  signedAgreementLockGuard,
  successPageGuard,
} from './pages/agreements-page/signed-agreement-back.guard';

const routes: Routes = [
  { path: '',
    title: 'Compas',
    canActivate: [pantherRedirectGuard],
    loadChildren: () => import('./pages/landing-page/landing-page.module').then((m) => m.LandingPageModule)
  },
  {
    path: 'account-portal',
    canActivate: [incompleteOrderRedirectGuard],
    loadChildren: () => import('./account-portal/account-portal.module').then((m) => m.AccountPortalModule),
    data: { title: 'Account Portal' }
  },
  {
    path: 'signup-personal-info',
    title: 'Set Up Your Account',
    canActivate: [signedAgreementLockGuard],
    loadChildren: () =>
      import('./pages/signup-personal-info/signup-personal-info.module').then((m) => m.SignupPersonalInfoModule),
  },
  // {
  //   path: 'choose-your-path',
  //   title: 'Choose Your Path',
  //   canActivate: [signedAgreementLockGuard],
  //   loadChildren: () =>
  //     import('./pages/choose-your-path/choose-your-path.module').then((m) => m.ChooseYourPathModule),
  // },
  Shell.childRoutes([
    {
      path: 'login',
      data: { page: 'login', title: 'Login' },
      loadChildren: () => import('./pages/login/login.module').then((m) => m.LoginModule),
    },
    {
      path: 'recover-password',
      data: { page: 'recover-password', title: 'Recover Password' },
      loadComponent: () => import('./pages/recover-password/recover-password.component').then((m) => m.RecoverPasswordComponent),
    },
    {
      path: 'create-password',
      data: { page: 'create-password', title: 'Create password' },
      loadComponent: () => import('./pages/create-new-password/create-new-password.component').then((m) => m.CreateNewPasswordComponent),
    },
    {
      path: 'subscription',
      data: { page: 'subscription', title: 'Subscription' },
      canActivate: [signedAgreementLockGuard, subscriptionSelectionGuard],
      loadChildren: () =>
        import('./pages/subscription-page/subscription-page.module').then((m) => m.SubscriptionPageModule),
    },
    {
      path: 'business-information',
      data: { title: 'Business Information' },
      canActivate: [signedAgreementLockGuard],
      loadChildren: () =>
        import('./pages/business-information-page/business-information-page.module').then(
          (m) => m.BusinessInformationPageModule,
        ),
    },
    {
      path: 'email-verification',
      data: { title: 'Email Verification' },
      loadChildren: () =>
        import('./pages/email-verification/email-verification.module').then((m) => m.EmailVerificationModule),
    },
    {
      path: 'business-information2',
      data: { title: 'Business Information 2' },
      canActivate: [signedAgreementLockGuard],
      loadChildren: () =>
        import('./pages/business-information-page2/business-information-page2.module').then(
          (m) => m.BusinessInformationPage2Module,
        ),
    },
    {
      path: 'bank-page',
      data: { title: 'Banking Information' },
      canActivate: [signedAgreementLockGuard],
      loadChildren: () => import('./pages/bank-page/bank-page.module').then((m) => m.BankPageModule),
    },
    {
      path: 'software-plans',
      data: { title: 'Software Plans' },
      canActivate: [signedAgreementLockGuard, pantherRedirectGuard],
      loadChildren: () => import('./pages/software-plans/software-plans.module').then((m) => m.SoftwarePlansModule),
    },
    {
      path: 'software-features',
      data: { title: 'Software Features' },
      canActivate: [signedAgreementLockGuard],
      loadChildren: () =>
        import('./pages/software-features/software-features.module').then((m) => m.SoftwareFeaturesModule),
    },
    {
      path: 'nrspay-plans',
      data: { title: 'NRS Pay Plans' },
      canActivate: [signedAgreementLockGuard],
      loadChildren: () => import('./pages/nrspay-plans/nrspay-plans.module').then((m) => m.NrspayPlansModule),
    },
    {
      path: 'equipment-services',
      data: { title: 'Equipment Services' },
      canActivate: [signedAgreementLockGuard],
      loadChildren: () =>
        import('./pages/equipment-services/equipment-services.module').then((m) => m.EquipmentServicesModule),
    },
    {
      path: 'summary',
      data: { title: 'Summary' },
      canActivate: [signedAgreementLockGuard],
      loadChildren: () => import('./pages/summary/summary.module').then((m) => m.SummaryModule),
    },
    {
      path: 'payment-plans',
      data: { title: 'Payment Plans' },
      canActivate: [signedAgreementLockGuard],
      loadChildren: () => import('./pages/payment-plans/payment-plans.module').then((m) => m.PaymentPlansModule),
    },
    {
      path: 'agreements',
      data: { title: 'Agreement' },
      canDeactivate: [signedAgreementBackGuard],
      loadChildren: () => import('./pages/agreements-page/agreements-page.module').then((m) => m.AgreementsPageModule),
    },
    {
      path: 'success',
      data: { title: 'Success' },
      canActivate: [successPageGuard],
      canDeactivate: [signedAgreementBackGuard],
      loadChildren: () => import('./pages/success-page/success-page.module').then((m) => m.SuccessPageModule),
    },
    {
      path: 'wizard',
      data: { title: 'Smart Wizard' },
      canActivate: [signedAgreementLockGuard],
      loadChildren: () => import('./pages/wizard-home/wizard-home.module').then((m) => m.WizardHomeModule),
    },
  ]),
  // Fallback when no prior route is matched
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  // 'computed' rewinds the browser history when a guard cancels a Back/Forward navigation.
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, canceledNavigationResolution: 'computed' }),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
